import apiHelper from "./helper";
import type {Meta, Theme, RefType} from "$lib/types";
import {PUBLIC_MEDIA_URL} from "$env/static/public"
import {UNEXPECTED_SERVER_RESPONSE} from "$lib/constants";

/**
  здесь подключаем справочники регионов, национальностей и других
  которые не требуется менять

 */

export const RefsApi = (userToken?: string) => {

  // const API_NAME = "events";
  // const EVENT_API_URL =  `${PUBLIC_API_URL}/${API_NAME}`;
  const { get, post } = apiHelper(userToken);

  return {

    /**
     * Список регионов
     */
    getRegions: async (params = {}) => {
      const {err,data} = await get("regions", {
        pagination: {
          limit: 100
        },
        sort: ['name:asc'],
        ...params,
      });

      if (err) {
        return {err}
      }
      const refItems: RefType[] = data?.data.map((i: any) => {return {value: i.id, name: i.attributes?.name}})

      return {refItems};
    },

    /**
     * Список народностей/национальностей
     */
    getNationalities: async (params = {}) => {
      const {data, err} = await get("nationalities", {
        pagination: {
          limit: 200
        },
        ...params,
      });

      if (err) {
        return {err}
      }
      const refItems: RefType[] = data?.data.map((i: any) => {return {value: i.id, name: i.attributes?.name}})

      return {refItems};
    },

    /**
     * Список типов образования
     */
    getEducations: async () => {
      const {data, err} = await get("educations", {});
      if (err) {
        return {err}
      }
      const refItems: RefType[] = data?.data.map((i: any) => {return {value: i.id, name: i.attributes?.name}})

      return {refItems};
    },

    getReligions: async () => {
      const {data, err}= await get("religions", {});
      if (err) {
        return {err}
      }
      const refItems: RefType[] = data?.data.map((i: any) => {return {value: i.id, name: i.attributes?.name}})

      return {refItems};
    },

    /**
     * Темы / Направления
     */
    getDirections: async (): Promise<{data: Theme[], err?: string, meta?: Meta}> => {
      const { data, err } = await get("directions?populate=*&pagination[limit]=100", {});

      if (err) { return {err, data: []} }

      if (!data?.data) return { err: UNEXPECTED_SERVER_RESPONSE, data: []}

      const list = data?.data.map((i: any) => ({
        id: i.id,
        value: i.id,
        title: i.attributes?.name,
        name: i.attributes?.name,
        img: i.attributes?.image?.data?.attributes?.url
          ? PUBLIC_MEDIA_URL + i.attributes.image.data.attributes.url
          : null,
      }));
      return { data: list, meta: data?.meta };
    },

    /**
     * Список Правовых форм
     */
    getLegalForms: async (): Promise<{refItems?: RefType[], err?: string, meta?: Meta}> => {
      const {data, err}= await get("legal-forms", {});
      if (err) {
        return {err}
      }
      const refItems: RefType[] = data?.data.map((i: any) => {return {value: i.id, name: i.attributes?.name}})

      return {refItems};
    },

    /**
     * Список сфер деятельности
     */
    getExpertFields: async (): Promise<{refItems?: RefType[], err?: string, meta?: Meta}> => {
      const {data, err}= await get("expert-fields", {});
      if (err) {
        return {err}
      }
      const refItems: RefType[] = data?.data.map((i: any) => {return {value: i.id, name: i.attributes?.name}})

      return {refItems};
    },

    /**
     * Список языковых семей
     */
    getLanguageFamilies: async () => {
      const {data, err} = await get("language-families", {});
      if (err) {
        return {err}
      }
      const refItems: RefType[] = data?.data.map((i: any) => {return {value: i.id, name: i.attributes?.name}})

      return {refItems};
    },

    /**
     * Список тем
     */
    getTopics: async (params = {}) => {
      const {data, err} = await get("topics-appeals", {
        pagination: {
          limit: 100,
        },
        ...params,
      });

      if (err) {
        return {err}
      }

      const refItems: RefType[] = data?.data.map((i: any) => {return {value: i.id, name: i.attributes?.name}})

      return {refItems};
    },

    /**
     * Список видео
     */
    getVideos: async (params = {}) => {
      const {data, err} = await get("video-banners", {
        populate: 'media',
        ...params,
      });

      if (err) {
        return {err}
      }

      return data;
    },

    /**
     * Список тем
     */
    getThemes: async (params = {}) => {
      const {data, err} = await get("themas", {
        pagination: {
          limit: 200
        },
        ...params,
      });

      if (err) {
        return {err}
      }
      const refItems: RefType[] = data?.data.map((i: any) => {return {value: i.id, name: i.attributes?.name}})

      return {refItems};
    },

    // Список авторов
    getAuthors: async (params = {}) => {
      const {data, err} = await get("authors", {
        pagination: {
          limit: 200
        },
        ...params,
      });

      if (err) {
        return {err}
      }
      const refItems: RefType[] = data?.data.map((i: any) => {return {value: i.id, name: i.attributes?.name}})

      return {refItems};
    },

    // Список языков
    getLanguages: async (params = {}) => {
      const {data, err} = await get("languages", {
        pagination: {
          limit: 200
        },
        ...params,
      });

      if (err) {
        return {err}
      }
      const refItems: RefType[] = data?.data.map((i: any) => {return {value: i.id, name: i.attributes?.name}})

      return {refItems};
    },

    // Список институтов
    getInstitutions: async (params = {}) => {
      const {data, err} = await get("institutions", {
        pagination: {
          limit: 200
        },
        ...params,
      });

      if (err) {
        return {err}
      }
      const refItems: RefType[] = data?.data.map((i: any) => {return {value: i.id, name: i.attributes?.name}})

      return {refItems};
    },
  }
}

